// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1GbKF","productName":"Table_productName__3b4df"};